/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BillingListInvoices200,
  BillingListInvoicesParams,
  BillingListPayments200,
  BillingListPaymentsParams,
  BillingQuoteParams,
  BillingSubscriptionWalletTransactions200,
  BillingSubscriptionWalletTransactionsParams,
  BillingWalletTransactions200,
  BillingWalletTransactionsParams,
  CancelSubscriptionDto,
  ClinicBillingStateResponse,
  ClinicOfferClaimResponse,
  ClinicOfferResponse,
  ClinicOffersResponse,
  EnterOfferCodeDto,
  InvoiceDownloadResponse,
  InvoiceResponse,
  MarkOfferSeenDto,
  PayInvoiceDto,
  PaymentStartResponse,
  PlanAccessResponse,
  PlanChangeQuoteResponse,
  PlanResponse,
  RefundEligibilityResponse,
  RefundRequestSummaryResponse,
  RequestRefundDto,
  SubscribeDto,
  SubscribeResultResponse,
  SubscriptionResponse,
  TopUpWalletDto,
  TrialPlanDto,
  WalletResponse,
  ZarinpalCallbackCallbackParams
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * فقط پلن‌های فعال و عمومی. پلن‌های خصوصی (قرارداد اختصاصی) و پلن‌های بایگانی‌شده در این فهرست نمی‌آیند و قابل انتخاب نیستند.
 * @summary فهرست پلن‌های قابل انتخاب
 */
export const billingListPlans = (

 signal?: AbortSignal
) => {


      return apiClient<PlanResponse[]>(
      {url: `/api/v1/billing/plans`, method: 'GET', signal
    },
      );
    }




export const getBillingListPlansQueryKey = () => {
    return [
    `/api/v1/billing/plans`
    ] as const;
    }


export const getBillingListPlansQueryOptions = <TData = Awaited<ReturnType<typeof billingListPlans>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPlans>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingListPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingListPlans>>> = ({ signal }) => billingListPlans(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingListPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingListPlansQueryResult = NonNullable<Awaited<ReturnType<typeof billingListPlans>>>
export type BillingListPlansQueryError = unknown


export function useBillingListPlans<TData = Awaited<ReturnType<typeof billingListPlans>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingListPlans>>,
          TError,
          Awaited<ReturnType<typeof billingListPlans>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingListPlans<TData = Awaited<ReturnType<typeof billingListPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingListPlans>>,
          TError,
          Awaited<ReturnType<typeof billingListPlans>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingListPlans<TData = Awaited<ReturnType<typeof billingListPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPlans>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست پلن‌های قابل انتخاب
 */

export function useBillingListPlans<TData = Awaited<ReturnType<typeof billingListPlans>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPlans>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingListPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * وضعیت اشتراک از روی تقویم محاسبه می‌شود، نه فقط از ستون ذخیره‌شده؛ بنابراین پایان دورهٔ آزمایشی بدون منتظر ماندن برای کار شبانه دیده می‌شود.
 * @summary وضعیت اشتراک، مصرف پلن و اعتبار پیامک
 */
export const billingSubscription = (

 signal?: AbortSignal
) => {


      return apiClient<ClinicBillingStateResponse>(
      {url: `/api/v1/billing/subscription`, method: 'GET', signal
    },
      );
    }




export const getBillingSubscriptionQueryKey = () => {
    return [
    `/api/v1/billing/subscription`
    ] as const;
    }


export const getBillingSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof billingSubscription>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscription>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingSubscriptionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingSubscription>>> = ({ signal }) => billingSubscription(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof billingSubscription>>>
export type BillingSubscriptionQueryError = unknown


export function useBillingSubscription<TData = Awaited<ReturnType<typeof billingSubscription>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscription>>,
          TError,
          Awaited<ReturnType<typeof billingSubscription>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSubscription<TData = Awaited<ReturnType<typeof billingSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscription>>,
          TError,
          Awaited<ReturnType<typeof billingSubscription>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSubscription<TData = Awaited<ReturnType<typeof billingSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscription>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت اشتراک، مصرف پلن و اعتبار پیامک
 */

export function useBillingSubscription<TData = Awaited<ReturnType<typeof billingSubscription>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscription>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ارتقا بی‌درنگ اعمال می‌شود و ارزش استفاده‌نشدهٔ دورهٔ فعلی از صورت‌حساب تازه کسر می‌گردد. تنزل پلن به‌طور پیش‌فرض برای پایان دورهٔ جاری زمان‌بندی می‌شود تا امکاناتی که بابتش پرداخت شده پیش از موعد گرفته نشود. پاسخ، صورت‌حسابی را که همین تغییر صادر کرد (invoice) همراه دارد.
 * @summary انتخاب یا تغییر پلن اشتراک
 */
export const billingSubscribe = (
    subscribeDto: SubscribeDto,
 signal?: AbortSignal
) => {


      return apiClient<SubscribeResultResponse>(
      {url: `/api/v1/billing/subscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subscribeDto, signal
    },
      );
    }




export const getBillingSubscribeMutationKey = () => ['billingSubscribe'] as const;

export const getBillingSubscribeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingSubscribe>>, TError,BillingSubscribeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingSubscribe>>, TError,BillingSubscribeMutationVariables, TContext> => {

const mutationKey = getBillingSubscribeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingSubscribe>>, BillingSubscribeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  billingSubscribe(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingSubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof billingSubscribe>>>
    export type BillingSubscribeMutationBody = SubscribeDto
    export type BillingSubscribeMutationError = void
    export type BillingSubscribeMutationVariables = {data: SubscribeDto}

    /**
 * @summary انتخاب یا تغییر پلن اشتراک
 */
export const useBillingSubscribe = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingSubscribe>>, TError,BillingSubscribeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingSubscribe>>,
        TError,
        BillingSubscribeMutationVariables,
        TContext
      > => {
      return useMutation(getBillingSubscribeMutationOptions(options), queryClient);
    }
    /**
 * بدون ثبت هیچ تغییری می‌گوید انتخاب این پلن امروز چقدر هزینه دارد: بهای پلن، اعتبار کسرشده از دورهٔ فعلی، مبلغ صورت‌حساب و زمان اعمال. همان محاسبه‌ای است که هنگام ثبت صورت‌حساب را می‌سازد.
 * @summary پیش‌نمایش هزینهٔ تغییر پلن
 */
export const billingQuote = (
    params: BillingQuoteParams,
 signal?: AbortSignal
) => {


      return apiClient<PlanChangeQuoteResponse>(
      {url: `/api/v1/billing/subscription/quote`, method: 'GET',
        params, signal
    },
      );
    }




export const getBillingQuoteQueryKey = (params?: BillingQuoteParams,) => {
    return [
    `/api/v1/billing/subscription/quote`, ...(params ? [params] : [])
    ] as const;
    }


export const getBillingQuoteQueryOptions = <TData = Awaited<ReturnType<typeof billingQuote>>, TError = void>(params: BillingQuoteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingQuote>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingQuoteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingQuote>>> = ({ signal }) => billingQuote(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingQuote>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof billingQuote>>>
export type BillingQuoteQueryError = void


export function useBillingQuote<TData = Awaited<ReturnType<typeof billingQuote>>, TError = void>(
 params: BillingQuoteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingQuote>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingQuote>>,
          TError,
          Awaited<ReturnType<typeof billingQuote>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingQuote<TData = Awaited<ReturnType<typeof billingQuote>>, TError = void>(
 params: BillingQuoteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingQuote>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingQuote>>,
          TError,
          Awaited<ReturnType<typeof billingQuote>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingQuote<TData = Awaited<ReturnType<typeof billingQuote>>, TError = void>(
 params: BillingQuoteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingQuote>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیش‌نمایش هزینهٔ تغییر پلن
 */

export function useBillingQuote<TData = Awaited<ReturnType<typeof billingQuote>>, TError = void>(
 params: BillingQuoteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingQuote>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingQuoteQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فقط در دورهٔ آزمایشی و بدون هیچ پرداختی. پایان دورهٔ آزمایشی برای جابه‌جایی میان پلن‌های ثابت عوض نمی‌شود؛ رفتن به نتیجه‌محور یا برگشتن از آن بی‌درنگ است.
 * @summary تغییر پلن دورهٔ آزمایشی
 */
export const billingTrialPlan = (
    trialPlanDto: TrialPlanDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicBillingStateResponse>(
      {url: `/api/v1/billing/subscription/trial-plan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trialPlanDto, signal
    },
      );
    }




export const getBillingTrialPlanMutationKey = () => ['billingTrialPlan'] as const;

export const getBillingTrialPlanMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingTrialPlan>>, TError,BillingTrialPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingTrialPlan>>, TError,BillingTrialPlanMutationVariables, TContext> => {

const mutationKey = getBillingTrialPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingTrialPlan>>, BillingTrialPlanMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  billingTrialPlan(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingTrialPlanMutationResult = NonNullable<Awaited<ReturnType<typeof billingTrialPlan>>>
    export type BillingTrialPlanMutationBody = TrialPlanDto
    export type BillingTrialPlanMutationError = void
    export type BillingTrialPlanMutationVariables = {data: TrialPlanDto}

    /**
 * @summary تغییر پلن دورهٔ آزمایشی
 */
export const useBillingTrialPlan = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingTrialPlan>>, TError,BillingTrialPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingTrialPlan>>,
        TError,
        BillingTrialPlanMutationVariables,
        TContext
      > => {
      return useMutation(getBillingTrialPlanMutationOptions(options), queryClient);
    }
    /**
 * تغییری که برای پایان دوره ثبت شده بود لغو می‌شود و پلن فعلی مثل قبل تمدید می‌شود.
 * @summary لغو تغییر پلنِ زمان‌بندی‌شده
 */
export const billingCancelScheduled = (

 signal?: AbortSignal
) => {


      return apiClient<ClinicBillingStateResponse>(
      {url: `/api/v1/billing/subscription/scheduled/cancel`, method: 'POST', signal
    },
      );
    }




export const getBillingCancelScheduledMutationKey = () => ['billingCancelScheduled'] as const;

export const getBillingCancelScheduledMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCancelScheduled>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingCancelScheduled>>, TError,void, TContext> => {

const mutationKey = getBillingCancelScheduledMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingCancelScheduled>>, void> = () => {


          return  billingCancelScheduled()
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingCancelScheduledMutationResult = NonNullable<Awaited<ReturnType<typeof billingCancelScheduled>>>

    export type BillingCancelScheduledMutationError = void


    /**
 * @summary لغو تغییر پلنِ زمان‌بندی‌شده
 */
export const useBillingCancelScheduled = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCancelScheduled>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingCancelScheduled>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getBillingCancelScheduledMutationOptions(options), queryClient);
    }
    /**
 * به‌طور پیش‌فرض تا پایان دورهٔ پرداخت‌شده فعال می‌ماند. پس از لغو، پروندهٔ بیماران همچنان قابل مشاهده و دریافت است.
 * @summary لغو اشتراک
 */
export const billingCancel = (
    cancelSubscriptionDto: CancelSubscriptionDto,
 signal?: AbortSignal
) => {


      return apiClient<SubscriptionResponse>(
      {url: `/api/v1/billing/subscription/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelSubscriptionDto, signal
    },
      );
    }




export const getBillingCancelMutationKey = () => ['billingCancel'] as const;

export const getBillingCancelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCancel>>, TError,BillingCancelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingCancel>>, TError,BillingCancelMutationVariables, TContext> => {

const mutationKey = getBillingCancelMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingCancel>>, BillingCancelMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  billingCancel(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingCancelMutationResult = NonNullable<Awaited<ReturnType<typeof billingCancel>>>
    export type BillingCancelMutationBody = CancelSubscriptionDto
    export type BillingCancelMutationError = void
    export type BillingCancelMutationVariables = {data: CancelSubscriptionDto}

    /**
 * @summary لغو اشتراک
 */
export const useBillingCancel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingCancel>>, TError,BillingCancelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingCancel>>,
        TError,
        BillingCancelMutationVariables,
        TContext
      > => {
      return useMutation(getBillingCancelMutationOptions(options), queryClient);
    }
    /**
 * @summary انصراف از لغو اشتراک
 */
export const billingResume = (

 signal?: AbortSignal
) => {


      return apiClient<SubscriptionResponse>(
      {url: `/api/v1/billing/subscription/resume`, method: 'POST', signal
    },
      );
    }




export const getBillingResumeMutationKey = () => ['billingResume'] as const;

export const getBillingResumeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingResume>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingResume>>, TError,void, TContext> => {

const mutationKey = getBillingResumeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingResume>>, void> = () => {


          return  billingResume()
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingResumeMutationResult = NonNullable<Awaited<ReturnType<typeof billingResume>>>

    export type BillingResumeMutationError = void


    /**
 * @summary انصراف از لغو اشتراک
 */
export const useBillingResume = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingResume>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingResume>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getBillingResumeMutationOptions(options), queryClient);
    }
    /**
 * @summary فهرست صورت‌حساب‌های کلینیک
 */
export const billingListInvoices = (
    params?: BillingListInvoicesParams,
 signal?: AbortSignal
) => {


      return apiClient<BillingListInvoices200>(
      {url: `/api/v1/billing/invoices`, method: 'GET',
        params, signal
    },
      );
    }




export const getBillingListInvoicesQueryKey = (params?: BillingListInvoicesParams,) => {
    return [
    `/api/v1/billing/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getBillingListInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof billingListInvoices>>, TError = unknown>(params?: BillingListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListInvoices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingListInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingListInvoices>>> = ({ signal }) => billingListInvoices(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingListInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingListInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof billingListInvoices>>>
export type BillingListInvoicesQueryError = unknown


export function useBillingListInvoices<TData = Awaited<ReturnType<typeof billingListInvoices>>, TError = unknown>(
 params: undefined |  BillingListInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingListInvoices>>,
          TError,
          Awaited<ReturnType<typeof billingListInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingListInvoices<TData = Awaited<ReturnType<typeof billingListInvoices>>, TError = unknown>(
 params?: BillingListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingListInvoices>>,
          TError,
          Awaited<ReturnType<typeof billingListInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingListInvoices<TData = Awaited<ReturnType<typeof billingListInvoices>>, TError = unknown>(
 params?: BillingListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست صورت‌حساب‌های کلینیک
 */

export function useBillingListInvoices<TData = Awaited<ReturnType<typeof billingListInvoices>>, TError = unknown>(
 params?: BillingListInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingListInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary جزئیات یک صورت‌حساب
 */
export const billingInvoice = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<InvoiceResponse>(
      {url: `/api/v1/billing/invoices/${id}`, method: 'GET', signal
    },
      );
    }




export const getBillingInvoiceQueryKey = (id: string,) => {
    return [
    `/api/v1/billing/invoices/${id}`
    ] as const;
    }


export const getBillingInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof billingInvoice>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoice>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingInvoice>>> = ({ signal }) => billingInvoice(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof billingInvoice>>>
export type BillingInvoiceQueryError = void


export function useBillingInvoice<TData = Awaited<ReturnType<typeof billingInvoice>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoice>>,
          TError,
          Awaited<ReturnType<typeof billingInvoice>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoice<TData = Awaited<ReturnType<typeof billingInvoice>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoice>>,
          TError,
          Awaited<ReturnType<typeof billingInvoice>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoice<TData = Awaited<ReturnType<typeof billingInvoice>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoice>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک صورت‌حساب
 */

export function useBillingInvoice<TData = Awaited<ReturnType<typeof billingInvoice>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoice>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * نشانی امضاشده و کوتاه‌عمر برمی‌گرداند. فایل در نخستین درخواست ساخته و ذخیره می‌شود تا نسخهٔ بایگانی‌شدهٔ حسابداری هرگز تغییر نکند.
 * @summary دریافت فایل PDF صورت‌حساب
 */
export const billingInvoicePdf = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<InvoiceDownloadResponse>(
      {url: `/api/v1/billing/invoices/${id}/pdf`, method: 'GET', signal
    },
      );
    }




export const getBillingInvoicePdfQueryKey = (id: string,) => {
    return [
    `/api/v1/billing/invoices/${id}/pdf`
    ] as const;
    }


export const getBillingInvoicePdfQueryOptions = <TData = Awaited<ReturnType<typeof billingInvoicePdf>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicePdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingInvoicePdfQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingInvoicePdf>>> = ({ signal }) => billingInvoicePdf(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingInvoicePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingInvoicePdfQueryResult = NonNullable<Awaited<ReturnType<typeof billingInvoicePdf>>>
export type BillingInvoicePdfQueryError = void


export function useBillingInvoicePdf<TData = Awaited<ReturnType<typeof billingInvoicePdf>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicePdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof billingInvoicePdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoicePdf<TData = Awaited<ReturnType<typeof billingInvoicePdf>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicePdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingInvoicePdf>>,
          TError,
          Awaited<ReturnType<typeof billingInvoicePdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingInvoicePdf<TData = Awaited<ReturnType<typeof billingInvoicePdf>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicePdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دریافت فایل PDF صورت‌حساب
 */

export function useBillingInvoicePdf<TData = Awaited<ReturnType<typeof billingInvoicePdf>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingInvoicePdf>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingInvoicePdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * اگر جلسهٔ پرداخت بازی برای همین صورت‌حساب وجود داشته باشد، همان نشانی بازگردانده می‌شود تا دو تراکنش هم‌زمان روی یک صورت‌حساب باز نشود.
 * @summary آغاز پرداخت صورت‌حساب از درگاه زرین‌پال
 */
export const billingPayInvoice = (
    id: string,
    payInvoiceDto: PayInvoiceDto,
 signal?: AbortSignal
) => {


      return apiClient<PaymentStartResponse>(
      {url: `/api/v1/billing/invoices/${id}/pay`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: payInvoiceDto, signal
    },
      );
    }




export const getBillingPayInvoiceMutationKey = () => ['billingPayInvoice'] as const;

export const getBillingPayInvoiceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPayInvoice>>, TError,BillingPayInvoiceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingPayInvoice>>, TError,BillingPayInvoiceMutationVariables, TContext> => {

const mutationKey = getBillingPayInvoiceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingPayInvoice>>, BillingPayInvoiceMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  billingPayInvoice(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingPayInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof billingPayInvoice>>>
    export type BillingPayInvoiceMutationBody = PayInvoiceDto
    export type BillingPayInvoiceMutationError = void
    export type BillingPayInvoiceMutationVariables = {id: string;data: PayInvoiceDto}

    /**
 * @summary آغاز پرداخت صورت‌حساب از درگاه زرین‌پال
 */
export const useBillingPayInvoice = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingPayInvoice>>, TError,BillingPayInvoiceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingPayInvoice>>,
        TError,
        BillingPayInvoiceMutationVariables,
        TContext
      > => {
      return useMutation(getBillingPayInvoiceMutationOptions(options), queryClient);
    }
    /**
 * @summary اعتبار کیف پیامک
 */
export const billingWalletBalance = (

 signal?: AbortSignal
) => {


      return apiClient<WalletResponse>(
      {url: `/api/v1/billing/wallet`, method: 'GET', signal
    },
      );
    }




export const getBillingWalletBalanceQueryKey = () => {
    return [
    `/api/v1/billing/wallet`
    ] as const;
    }


export const getBillingWalletBalanceQueryOptions = <TData = Awaited<ReturnType<typeof billingWalletBalance>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingWalletBalanceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingWalletBalance>>> = ({ signal }) => billingWalletBalance(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingWalletBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingWalletBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof billingWalletBalance>>>
export type BillingWalletBalanceQueryError = unknown


export function useBillingWalletBalance<TData = Awaited<ReturnType<typeof billingWalletBalance>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingWalletBalance>>,
          TError,
          Awaited<ReturnType<typeof billingWalletBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingWalletBalance<TData = Awaited<ReturnType<typeof billingWalletBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingWalletBalance>>,
          TError,
          Awaited<ReturnType<typeof billingWalletBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingWalletBalance<TData = Awaited<ReturnType<typeof billingWalletBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary اعتبار کیف پیامک
 */

export function useBillingWalletBalance<TData = Awaited<ReturnType<typeof billingWalletBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingWalletBalanceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * شارژها، اعتبار هدیهٔ پلن و کسر بهای هر پیامک ارسال‌شده.
 * @summary گردش کیف پیامک
 */
export const billingWalletTransactions = (
    params?: BillingWalletTransactionsParams,
 signal?: AbortSignal
) => {


      return apiClient<BillingWalletTransactions200>(
      {url: `/api/v1/billing/wallet/transactions`, method: 'GET',
        params, signal
    },
      );
    }




export const getBillingWalletTransactionsQueryKey = (params?: BillingWalletTransactionsParams,) => {
    return [
    `/api/v1/billing/wallet/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getBillingWalletTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof billingWalletTransactions>>, TError = unknown>(params?: BillingWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingWalletTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingWalletTransactions>>> = ({ signal }) => billingWalletTransactions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingWalletTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingWalletTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof billingWalletTransactions>>>
export type BillingWalletTransactionsQueryError = unknown


export function useBillingWalletTransactions<TData = Awaited<ReturnType<typeof billingWalletTransactions>>, TError = unknown>(
 params: undefined |  BillingWalletTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingWalletTransactions>>,
          TError,
          Awaited<ReturnType<typeof billingWalletTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingWalletTransactions<TData = Awaited<ReturnType<typeof billingWalletTransactions>>, TError = unknown>(
 params?: BillingWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingWalletTransactions>>,
          TError,
          Awaited<ReturnType<typeof billingWalletTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingWalletTransactions<TData = Awaited<ReturnType<typeof billingWalletTransactions>>, TError = unknown>(
 params?: BillingWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گردش کیف پیامک
 */

export function useBillingWalletTransactions<TData = Awaited<ReturnType<typeof billingWalletTransactions>>, TError = unknown>(
 params?: BillingWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingWalletTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingWalletTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مبلغ به **ریال** ارسال می‌شود. اعتبار پس از تأیید درگاه به کیف افزوده می‌شود.
 * @summary شارژ کیف پیامک از درگاه زرین‌پال
 */
export const billingTopUp = (
    topUpWalletDto: TopUpWalletDto,
 signal?: AbortSignal
) => {


      return apiClient<PaymentStartResponse>(
      {url: `/api/v1/billing/wallet/top-up`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: topUpWalletDto, signal
    },
      );
    }




export const getBillingTopUpMutationKey = () => ['billingTopUp'] as const;

export const getBillingTopUpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingTopUp>>, TError,BillingTopUpMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingTopUp>>, TError,BillingTopUpMutationVariables, TContext> => {

const mutationKey = getBillingTopUpMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingTopUp>>, BillingTopUpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  billingTopUp(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingTopUpMutationResult = NonNullable<Awaited<ReturnType<typeof billingTopUp>>>
    export type BillingTopUpMutationBody = TopUpWalletDto
    export type BillingTopUpMutationError = void
    export type BillingTopUpMutationVariables = {data: TopUpWalletDto}

    /**
 * @summary شارژ کیف پیامک از درگاه زرین‌پال
 */
export const useBillingTopUp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingTopUp>>, TError,BillingTopUpMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingTopUp>>,
        TError,
        BillingTopUpMutationVariables,
        TContext
      > => {
      return useMutation(getBillingTopUpMutationOptions(options), queryClient);
    }
    /**
 * @summary اعتبار کیف اشتراک
 */
export const billingSubscriptionWalletBalance = (

 signal?: AbortSignal
) => {


      return apiClient<WalletResponse>(
      {url: `/api/v1/billing/subscription-wallet`, method: 'GET', signal
    },
      );
    }




export const getBillingSubscriptionWalletBalanceQueryKey = () => {
    return [
    `/api/v1/billing/subscription-wallet`
    ] as const;
    }


export const getBillingSubscriptionWalletBalanceQueryOptions = <TData = Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingSubscriptionWalletBalanceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>> = ({ signal }) => billingSubscriptionWalletBalance(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingSubscriptionWalletBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>>
export type BillingSubscriptionWalletBalanceQueryError = unknown


export function useBillingSubscriptionWalletBalance<TData = Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>,
          TError,
          Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSubscriptionWalletBalance<TData = Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>,
          TError,
          Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSubscriptionWalletBalance<TData = Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary اعتبار کیف اشتراک
 */

export function useBillingSubscriptionWalletBalance<TData = Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingSubscriptionWalletBalanceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * شارژها، اصلاحات دستی و کسر خودکار بابت تمدید اشتراک.
 * @summary گردش کیف اشتراک
 */
export const billingSubscriptionWalletTransactions = (
    params?: BillingSubscriptionWalletTransactionsParams,
 signal?: AbortSignal
) => {


      return apiClient<BillingSubscriptionWalletTransactions200>(
      {url: `/api/v1/billing/subscription-wallet/transactions`, method: 'GET',
        params, signal
    },
      );
    }




export const getBillingSubscriptionWalletTransactionsQueryKey = (params?: BillingSubscriptionWalletTransactionsParams,) => {
    return [
    `/api/v1/billing/subscription-wallet/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getBillingSubscriptionWalletTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError = unknown>(params?: BillingSubscriptionWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingSubscriptionWalletTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>> = ({ signal }) => billingSubscriptionWalletTransactions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingSubscriptionWalletTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>>
export type BillingSubscriptionWalletTransactionsQueryError = unknown


export function useBillingSubscriptionWalletTransactions<TData = Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError = unknown>(
 params: undefined |  BillingSubscriptionWalletTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>,
          TError,
          Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSubscriptionWalletTransactions<TData = Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError = unknown>(
 params?: BillingSubscriptionWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>,
          TError,
          Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingSubscriptionWalletTransactions<TData = Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError = unknown>(
 params?: BillingSubscriptionWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گردش کیف اشتراک
 */

export function useBillingSubscriptionWalletTransactions<TData = Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError = unknown>(
 params?: BillingSubscriptionWalletTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingSubscriptionWalletTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مبلغ به **ریال** ارسال می‌شود. تمدید دورهٔ بعدی، در صورت کافی بودن این اعتبار، بدون نیاز به مراجعهٔ دوبارهٔ درگاه انجام می‌شود.
 * @summary شارژ کیف اشتراک از درگاه زرین‌پال
 */
export const billingSubscriptionWalletTopUp = (
    topUpWalletDto: TopUpWalletDto,
 signal?: AbortSignal
) => {


      return apiClient<PaymentStartResponse>(
      {url: `/api/v1/billing/subscription-wallet/top-up`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: topUpWalletDto, signal
    },
      );
    }




export const getBillingSubscriptionWalletTopUpMutationKey = () => ['billingSubscriptionWalletTopUp'] as const;

export const getBillingSubscriptionWalletTopUpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTopUp>>, TError,BillingSubscriptionWalletTopUpMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTopUp>>, TError,BillingSubscriptionWalletTopUpMutationVariables, TContext> => {

const mutationKey = getBillingSubscriptionWalletTopUpMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingSubscriptionWalletTopUp>>, BillingSubscriptionWalletTopUpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  billingSubscriptionWalletTopUp(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingSubscriptionWalletTopUpMutationResult = NonNullable<Awaited<ReturnType<typeof billingSubscriptionWalletTopUp>>>
    export type BillingSubscriptionWalletTopUpMutationBody = TopUpWalletDto
    export type BillingSubscriptionWalletTopUpMutationError = void
    export type BillingSubscriptionWalletTopUpMutationVariables = {data: TopUpWalletDto}

    /**
 * @summary شارژ کیف اشتراک از درگاه زرین‌پال
 */
export const useBillingSubscriptionWalletTopUp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingSubscriptionWalletTopUp>>, TError,BillingSubscriptionWalletTopUpMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingSubscriptionWalletTopUp>>,
        TError,
        BillingSubscriptionWalletTopUpMutationVariables,
        TContext
      > => {
      return useMutation(getBillingSubscriptionWalletTopUpMutationOptions(options), queryClient);
    }
    /**
 * آیا کلینیک می‌تواند بازگشت وجه نخستین دورهٔ پرداختی را درخواست کند، چه مبلغی و تا چه تاریخی؛ همراه آخرین درخواست ثبت‌شده. مهلت از سیاست قیمت‌گذاری کنسول خوانده می‌شود.
 * @summary وضعیت ضمانت بازگشت وجه
 */
export const billingRefundEligibility = (

 signal?: AbortSignal
) => {


      return apiClient<RefundEligibilityResponse>(
      {url: `/api/v1/billing/refund`, method: 'GET', signal
    },
      );
    }




export const getBillingRefundEligibilityQueryKey = () => {
    return [
    `/api/v1/billing/refund`
    ] as const;
    }


export const getBillingRefundEligibilityQueryOptions = <TData = Awaited<ReturnType<typeof billingRefundEligibility>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingRefundEligibility>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingRefundEligibilityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingRefundEligibility>>> = ({ signal }) => billingRefundEligibility(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingRefundEligibility>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingRefundEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof billingRefundEligibility>>>
export type BillingRefundEligibilityQueryError = void


export function useBillingRefundEligibility<TData = Awaited<ReturnType<typeof billingRefundEligibility>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingRefundEligibility>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingRefundEligibility>>,
          TError,
          Awaited<ReturnType<typeof billingRefundEligibility>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingRefundEligibility<TData = Awaited<ReturnType<typeof billingRefundEligibility>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingRefundEligibility>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingRefundEligibility>>,
          TError,
          Awaited<ReturnType<typeof billingRefundEligibility>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingRefundEligibility<TData = Awaited<ReturnType<typeof billingRefundEligibility>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingRefundEligibility>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت ضمانت بازگشت وجه
 */

export function useBillingRefundEligibility<TData = Awaited<ReturnType<typeof billingRefundEligibility>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingRefundEligibility>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingRefundEligibilityQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مبلغ پس از بررسی به شبای ثبت‌شده واریز می‌شود. با واریز، اشتراک همان روز پایان می‌یابد و پنل فقط‌خواندنی می‌شود؛ پرونده‌ها و اطلاعات حذف نمی‌شوند و همیشه قابل مشاهده و دریافت‌اند. شبا و نام صاحب حساب رمزگذاری‌شده نگهداری می‌شوند.
 * @summary درخواست بازگشت وجه
 */
export const billingRequestRefund = (
    requestRefundDto: RequestRefundDto,
 signal?: AbortSignal
) => {


      return apiClient<RefundRequestSummaryResponse>(
      {url: `/api/v1/billing/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestRefundDto, signal
    },
      );
    }




export const getBillingRequestRefundMutationKey = () => ['billingRequestRefund'] as const;

export const getBillingRequestRefundMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingRequestRefund>>, TError,BillingRequestRefundMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof billingRequestRefund>>, TError,BillingRequestRefundMutationVariables, TContext> => {

const mutationKey = getBillingRequestRefundMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof billingRequestRefund>>, BillingRequestRefundMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  billingRequestRefund(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BillingRequestRefundMutationResult = NonNullable<Awaited<ReturnType<typeof billingRequestRefund>>>
    export type BillingRequestRefundMutationBody = RequestRefundDto
    export type BillingRequestRefundMutationError = void
    export type BillingRequestRefundMutationVariables = {data: RequestRefundDto}

    /**
 * @summary درخواست بازگشت وجه
 */
export const useBillingRequestRefund = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof billingRequestRefund>>, TError,BillingRequestRefundMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof billingRequestRefund>>,
        TError,
        BillingRequestRefundMutationVariables,
        TContext
      > => {
      return useMutation(getBillingRequestRefundMutationOptions(options), queryClient);
    }
    /**
 * @summary تاریخچهٔ پرداخت‌های کلینیک به بوکورا
 */
export const billingListPayments = (
    params?: BillingListPaymentsParams,
 signal?: AbortSignal
) => {


      return apiClient<BillingListPayments200>(
      {url: `/api/v1/billing/payments`, method: 'GET',
        params, signal
    },
      );
    }




export const getBillingListPaymentsQueryKey = (params?: BillingListPaymentsParams,) => {
    return [
    `/api/v1/billing/payments`, ...(params ? [params] : [])
    ] as const;
    }


export const getBillingListPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof billingListPayments>>, TError = void>(params?: BillingListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPayments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingListPaymentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingListPayments>>> = ({ signal }) => billingListPayments(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingListPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingListPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof billingListPayments>>>
export type BillingListPaymentsQueryError = void


export function useBillingListPayments<TData = Awaited<ReturnType<typeof billingListPayments>>, TError = void>(
 params: undefined |  BillingListPaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingListPayments>>,
          TError,
          Awaited<ReturnType<typeof billingListPayments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingListPayments<TData = Awaited<ReturnType<typeof billingListPayments>>, TError = void>(
 params?: BillingListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingListPayments>>,
          TError,
          Awaited<ReturnType<typeof billingListPayments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingListPayments<TData = Awaited<ReturnType<typeof billingListPayments>>, TError = void>(
 params?: BillingListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPayments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تاریخچهٔ پرداخت‌های کلینیک به بوکورا
 */

export function useBillingListPayments<TData = Awaited<ReturnType<typeof billingListPayments>>, TError = void>(
 params?: BillingListPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingListPayments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingListPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * زرین‌پال مرورگر کاربر را به این نشانی برمی‌گرداند. نتیجه با یک درخواست سرور-به-سرور تأیید می‌شود و سپس مرورگر به پنل کلینیک هدایت می‌گردد. این مسیر توکن ندارد و صحت آن با یکتا بودن Authority تضمین می‌شود.
 * @summary بازگشت از درگاه زرین‌پال
 */
export const zarinpalCallbackCallback = (
    params: ZarinpalCallbackCallbackParams,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/billing/zarinpal/callback`, method: 'GET',
        params, signal
    },
      );
    }




export const getZarinpalCallbackCallbackQueryKey = (params?: ZarinpalCallbackCallbackParams,) => {
    return [
    `/api/v1/billing/zarinpal/callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getZarinpalCallbackCallbackQueryOptions = <TData = Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError = unknown>(params: ZarinpalCallbackCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getZarinpalCallbackCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof zarinpalCallbackCallback>>> = ({ signal }) => zarinpalCallbackCallback(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ZarinpalCallbackCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof zarinpalCallbackCallback>>>
export type ZarinpalCallbackCallbackQueryError = unknown


export function useZarinpalCallbackCallback<TData = Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError = unknown>(
 params: ZarinpalCallbackCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof zarinpalCallbackCallback>>,
          TError,
          Awaited<ReturnType<typeof zarinpalCallbackCallback>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useZarinpalCallbackCallback<TData = Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError = unknown>(
 params: ZarinpalCallbackCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof zarinpalCallbackCallback>>,
          TError,
          Awaited<ReturnType<typeof zarinpalCallbackCallback>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useZarinpalCallbackCallback<TData = Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError = unknown>(
 params: ZarinpalCallbackCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary بازگشت از درگاه زرین‌پال
 */

export function useZarinpalCallbackCallback<TData = Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError = unknown>(
 params: ZarinpalCallbackCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof zarinpalCallbackCallback>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getZarinpalCallbackCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * برای همهٔ کارکنان کلینیک. بدون اشتراک فعال هیچ بخشی قفل نیست. شامل هیچ مبلغی نیست. برای بخش قفلی که کلینیک از قبل در آن اطلاعات دارد hasData=true است.
 * @summary قابلیت‌های باز و قفل پلن جاری کلینیک
 */
export const planAccessGet = (

 signal?: AbortSignal
) => {


      return apiClient<PlanAccessResponse>(
      {url: `/api/v1/billing/plan-access`, method: 'GET', signal
    },
      );
    }




export const getPlanAccessGetQueryKey = () => {
    return [
    `/api/v1/billing/plan-access`
    ] as const;
    }


export const getPlanAccessGetQueryOptions = <TData = Awaited<ReturnType<typeof planAccessGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planAccessGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanAccessGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof planAccessGet>>> = ({ signal }) => planAccessGet(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof planAccessGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanAccessGetQueryResult = NonNullable<Awaited<ReturnType<typeof planAccessGet>>>
export type PlanAccessGetQueryError = unknown


export function usePlanAccessGet<TData = Awaited<ReturnType<typeof planAccessGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof planAccessGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof planAccessGet>>,
          TError,
          Awaited<ReturnType<typeof planAccessGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanAccessGet<TData = Awaited<ReturnType<typeof planAccessGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planAccessGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof planAccessGet>>,
          TError,
          Awaited<ReturnType<typeof planAccessGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanAccessGet<TData = Awaited<ReturnType<typeof planAccessGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planAccessGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary قابلیت‌های باز و قفل پلن جاری کلینیک
 */

export function usePlanAccessGet<TData = Awaited<ReturnType<typeof planAccessGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planAccessGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanAccessGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary پیشنهادهای فعال کلینیک و پیشنهاد ویژه
 */
export const offersList = (

 signal?: AbortSignal
) => {


      return apiClient<ClinicOffersResponse>(
      {url: `/api/v1/billing/offers`, method: 'GET', signal
    },
      );
    }




export const getOffersListQueryKey = () => {
    return [
    `/api/v1/billing/offers`
    ] as const;
    }


export const getOffersListQueryOptions = <TData = Awaited<ReturnType<typeof offersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOffersListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof offersList>>> = ({ signal }) => offersList(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof offersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OffersListQueryResult = NonNullable<Awaited<ReturnType<typeof offersList>>>
export type OffersListQueryError = unknown


export function useOffersList<TData = Awaited<ReturnType<typeof offersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof offersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof offersList>>,
          TError,
          Awaited<ReturnType<typeof offersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffersList<TData = Awaited<ReturnType<typeof offersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof offersList>>,
          TError,
          Awaited<ReturnType<typeof offersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOffersList<TData = Awaited<ReturnType<typeof offersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیشنهادهای فعال کلینیک و پیشنهاد ویژه
 */

export function useOffersList<TData = Awaited<ReturnType<typeof offersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof offersList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOffersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary ثبت کد پیشنهاد
 */
export const offersEnterCode = (
    enterOfferCodeDto: EnterOfferCodeDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicOfferResponse>(
      {url: `/api/v1/billing/offers/code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enterOfferCodeDto, signal
    },
      );
    }




export const getOffersEnterCodeMutationKey = () => ['offersEnterCode'] as const;

export const getOffersEnterCodeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersEnterCode>>, TError,OffersEnterCodeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof offersEnterCode>>, TError,OffersEnterCodeMutationVariables, TContext> => {

const mutationKey = getOffersEnterCodeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offersEnterCode>>, OffersEnterCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  offersEnterCode(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OffersEnterCodeMutationResult = NonNullable<Awaited<ReturnType<typeof offersEnterCode>>>
    export type OffersEnterCodeMutationBody = EnterOfferCodeDto
    export type OffersEnterCodeMutationError = void
    export type OffersEnterCodeMutationVariables = {data: EnterOfferCodeDto}

    /**
 * @summary ثبت کد پیشنهاد
 */
export const useOffersEnterCode = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersEnterCode>>, TError,OffersEnterCodeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof offersEnterCode>>,
        TError,
        OffersEnterCodeMutationVariables,
        TContext
      > => {
      return useMutation(getOffersEnterCodeMutationOptions(options), queryClient);
    }
    /**
 * شمارش مهلت شخصی را شروع و ثابت می‌کند. در حالت ورود پشتیبان کاری انجام نمی‌دهد.
 * @summary ثبت دیده‌شدن پیشنهاد
 */
export const offersMarkSeen = (
    grantId: string,
    markOfferSeenDto: MarkOfferSeenDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicOfferResponse>(
      {url: `/api/v1/billing/offers/${grantId}/seen`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: markOfferSeenDto, signal
    },
      );
    }




export const getOffersMarkSeenMutationKey = () => ['offersMarkSeen'] as const;

export const getOffersMarkSeenMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersMarkSeen>>, TError,OffersMarkSeenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof offersMarkSeen>>, TError,OffersMarkSeenMutationVariables, TContext> => {

const mutationKey = getOffersMarkSeenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offersMarkSeen>>, OffersMarkSeenMutationVariables> = (props) => {
          const {grantId,data} = props ?? {};

          return  offersMarkSeen(grantId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OffersMarkSeenMutationResult = NonNullable<Awaited<ReturnType<typeof offersMarkSeen>>>
    export type OffersMarkSeenMutationBody = MarkOfferSeenDto
    export type OffersMarkSeenMutationError = void
    export type OffersMarkSeenMutationVariables = {grantId: string;data: MarkOfferSeenDto}

    /**
 * @summary ثبت دیده‌شدن پیشنهاد
 */
export const useOffersMarkSeen = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersMarkSeen>>, TError,OffersMarkSeenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof offersMarkSeen>>,
        TError,
        OffersMarkSeenMutationVariables,
        TContext
      > => {
      return useMutation(getOffersMarkSeenMutationOptions(options), queryClient);
    }
    /**
 * @summary بستن کارت پیشنهاد
 */
export const offersDismiss = (
    grantId: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/billing/offers/${grantId}/dismiss`, method: 'POST', signal
    },
      );
    }




export const getOffersDismissMutationKey = () => ['offersDismiss'] as const;

export const getOffersDismissMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersDismiss>>, TError,OffersDismissMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof offersDismiss>>, TError,OffersDismissMutationVariables, TContext> => {

const mutationKey = getOffersDismissMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offersDismiss>>, OffersDismissMutationVariables> = (props) => {
          const {grantId} = props ?? {};

          return  offersDismiss(grantId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OffersDismissMutationResult = NonNullable<Awaited<ReturnType<typeof offersDismiss>>>

    export type OffersDismissMutationError = void
    export type OffersDismissMutationVariables = {grantId: string}

    /**
 * @summary بستن کارت پیشنهاد
 */
export const useOffersDismiss = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersDismiss>>, TError,OffersDismissMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof offersDismiss>>,
        TError,
        OffersDismissMutationVariables,
        TContext
      > => {
      return useMutation(getOffersDismissMutationOptions(options), queryClient);
    }
    /**
 * فقط برای پیشنهادهای بدون تخفیف قیمتی در دورهٔ آزمایشی؛ در غیر این صورت redeemed=false.
 * @summary دریافت پیشنهاد دورهٔ آزمایشی
 */
export const offersClaim = (
    grantId: string,
 signal?: AbortSignal
) => {


      return apiClient<ClinicOfferClaimResponse>(
      {url: `/api/v1/billing/offers/${grantId}/claim`, method: 'POST', signal
    },
      );
    }




export const getOffersClaimMutationKey = () => ['offersClaim'] as const;

export const getOffersClaimMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersClaim>>, TError,OffersClaimMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof offersClaim>>, TError,OffersClaimMutationVariables, TContext> => {

const mutationKey = getOffersClaimMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offersClaim>>, OffersClaimMutationVariables> = (props) => {
          const {grantId} = props ?? {};

          return  offersClaim(grantId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OffersClaimMutationResult = NonNullable<Awaited<ReturnType<typeof offersClaim>>>

    export type OffersClaimMutationError = void
    export type OffersClaimMutationVariables = {grantId: string}

    /**
 * @summary دریافت پیشنهاد دورهٔ آزمایشی
 */
export const useOffersClaim = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offersClaim>>, TError,OffersClaimMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof offersClaim>>,
        TError,
        OffersClaimMutationVariables,
        TContext
      > => {
      return useMutation(getOffersClaimMutationOptions(options), queryClient);
    }
